module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_3.a4bd5ebc.png";